var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 95,
    viewBox: "0 0 124 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1328_6183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M59.5 95C91.2564 95 117 93.433 117 91.5C117 89.567 91.2564 88 59.5 88C27.7436 88 2 89.567 2 91.5C2 93.433 27.7436 95 59.5 95Z",
    fill: "#E1E7F2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M111.935 38C110.481 38 109.096 38.5421 108 39.5154L112.004 44L117 40.8214C116.481 40.0205 115.8 39.3429 115.004 38.8624C114.069 38.308 113.008 38 111.935 38Z",
    fill: "#FCA76A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M112 44V50C115.217 49.8061 117.807 47.2242 118 44H112Z",
    fill: "#FCA76A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M114 43H119C118.952 42.2986 118.709 41.6161 118.286 41L114 43Z",
    fill: "#FCA76A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M107.719 40C106.601 41.1036 106 42.5338 106 44.0653C106 47.2297 108.657 49.8198 112 50V44.2005L107.719 40Z",
    fill: "#FCA76A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.4947 17.5571L19.019 17.5682C18.8751 16.9601 18.6428 16.3851 18.333 15.8655L18.7202 15.4674C19.2956 14.8704 19.2734 13.9305 18.687 13.3556C18.0896 12.7807 17.1491 12.8028 16.5738 13.3888L16.2418 13.7315C15.7218 13.4109 15.1575 13.1676 14.549 13.0128L14.5379 12.46C14.5269 11.6308 13.8409 10.9784 13.0221 11.0005C12.1923 11.0116 11.5395 11.6971 11.5616 12.5153L11.5727 12.9907C10.9642 13.1345 10.3888 13.3667 9.86882 13.6762L9.4705 13.2893C8.87303 12.7143 7.93257 12.7364 7.35723 13.3224C6.78189 13.9195 6.80402 14.8593 7.39042 15.4342L7.73342 15.7659C7.41255 16.2856 7.16914 16.8495 7.01424 17.4576L6.46103 17.4687C5.63121 17.4797 4.97842 18.1652 5.00055 18.9834C5.01161 19.8127 5.69759 20.465 6.51635 20.4429L6.99211 20.4318C7.13595 21.0399 7.3683 21.6149 7.67809 22.1345L7.29085 22.5326C6.7155 23.1296 6.73763 24.0695 7.32404 24.6444C7.92151 25.2193 8.86197 25.1972 9.43731 24.6112L9.75817 24.2685C10.2782 24.5891 10.8425 24.8324 11.451 24.9872L11.4621 25.54C11.4731 26.3692 12.1591 27.0216 12.9779 26.9995C13.8077 26.9884 14.4605 26.3029 14.4384 25.4847L14.4273 25.0093C15.0358 24.8655 15.6112 24.6333 16.1312 24.3238L16.5295 24.7107C17.127 25.2857 18.0674 25.2636 18.6428 24.6776C19.2181 24.0805 19.196 23.1407 18.6096 22.5658L18.2666 22.2451C18.5874 21.7255 18.8309 21.1616 18.9858 20.5535L19.539 20.5424C20.3688 20.5313 21.0216 19.8458 20.9995 19.0276C20.9995 18.1984 20.3135 17.5461 19.4947 17.5571ZM17.4478 18.9281C17.4921 21.3827 15.5337 23.4061 13.0774 23.4503C10.6212 23.4945 8.59643 21.5375 8.55217 19.0829C8.50791 16.6284 10.4663 14.605 12.9225 14.5608C15.3788 14.5165 17.4036 16.4736 17.4478 18.9281Z",
    fill: "#9EC1F0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.0003 19.0532C10.0358 20.7097 11.3965 22.0348 13.0531 21.9993C14.7096 21.9638 16.0348 20.6032 15.9993 18.9468C15.9638 17.2903 14.6031 15.9652 12.9347 16.0007C11.29 16.0244 9.97665 17.385 10.0003 19.0532Z",
    fill: "#9EC1F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M28.0653 11.1826H27.7725C27.6937 10.7993 27.5473 10.4386 27.3671 10.1116L27.6149 9.86358C27.9752 9.50282 27.9752 8.9053 27.6149 8.54453C27.2545 8.18377 26.6577 8.18377 26.2973 8.54453L26.0946 8.74746C25.7793 8.54453 25.4189 8.3867 25.0473 8.28523V7.93574C25.0473 7.41714 24.6306 7 24.1126 7C23.5946 7 23.1779 7.41714 23.1779 7.93574V8.22886C22.795 8.30778 22.4347 8.45434 22.1081 8.63472L21.8604 8.3867C21.5 8.02593 20.9032 8.02593 20.5428 8.3867C20.1824 8.74746 20.1824 9.34498 20.5428 9.70575L20.7455 9.90868C20.5428 10.2244 20.3851 10.5851 20.2838 10.9572H19.9347C19.4167 10.9572 19 11.3743 19 11.8929C19 12.4115 19.4167 12.8286 19.9347 12.8286H20.2275C20.3063 13.212 20.4527 13.5727 20.6329 13.8997L20.3851 14.1477C20.0248 14.5085 20.0248 15.106 20.3851 15.4667C20.7455 15.8275 21.3423 15.8275 21.7027 15.4667L21.9054 15.2638C22.2207 15.4667 22.5811 15.6246 22.9527 15.726V16.0643C22.9527 16.5829 23.3694 17 23.8874 17C24.4054 17 24.8221 16.5829 24.8221 16.0643V15.7711C25.205 15.6922 25.5653 15.5457 25.8919 15.3653L26.1396 15.6133C26.5 15.9741 27.0968 15.9741 27.4572 15.6133C27.8176 15.2525 27.8176 14.655 27.4572 14.2943L27.2545 14.0913C27.4572 13.7756 27.6149 13.4149 27.7162 13.0428H28.0653C28.5833 13.0428 29 12.6257 29 12.1071C29 11.5998 28.5833 11.1826 28.0653 11.1826ZM26.7703 12.0169C26.7703 13.5502 25.5315 14.7903 24 14.7903C22.4685 14.7903 21.2297 13.5502 21.2297 12.0169C21.2297 10.4837 22.4685 9.24352 24 9.24352C25.5315 9.24352 26.7703 10.4837 26.7703 12.0169Z",
    fill: "#9EC1F0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M22 12C22 13.1026 22.8974 14 24 14C25.1026 14 26 13.1026 26 12C26 10.8974 25.1026 10 24 10C22.8974 10 22 10.8974 22 12Z",
    fill: "#9EC1F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M37 11H34V14H37V11Z",
    fill: "#FCA76A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M41 9H38V14H41V9Z",
    fill: "#FCA76A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M46 7H43V14H46V7Z",
    fill: "#FCA76A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M50 5H47V14H50V5Z",
    fill: "#FCA76A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M104 17H19V71H104V17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M68 72H53V89H68V72Z",
    fill: "#8C92AB"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M68 72V89H65.9708C66.1091 87.3045 66.2706 82.1842 63.5381 78.262C61.0015 74.6336 55.548 74.2154 53 74.2493V72H68Z",
    fill: "#757D9C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M74.6184 87H45.3704C42.9611 87 41 88.7949 41 91H79C78.9888 88.7949 77.0389 87 74.6184 87Z",
    fill: "#4D4D4D"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M74.6184 87H45.3704C42.9611 87 41 88.7949 41 91H79C78.9888 88.7949 77.0389 87 74.6184 87Z",
    fill: "#8C92AB"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M102.744 15H18.256C17.5607 15 17 15.5607 17 16.256V71.744C17 72.4393 17.5607 73 18.256 73H102.744C103.439 73 104 72.4393 104 71.744V16.2672C104 15.5719 103.439 15 102.744 15ZM101.903 66.9219C101.903 67.662 101.309 68.2676 100.568 68.2676H19.9269C19.1868 68.2676 18.5924 67.662 18.5924 66.9219V18.0951C18.5924 17.355 19.1868 16.7494 19.9269 16.7494H100.568C101.309 16.7494 101.903 17.355 101.903 18.0951V66.9219Z",
    fill: "#8C92AB"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M66.551 70H63.449C63.2041 70 63 69.7727 63 69.5C63 69.2273 63.2041 69 63.449 69H66.551C66.7959 69 67 69.2273 67 69.5C67 69.7727 66.7959 70 66.551 70Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M66.7617 69C66.7927 69.0732 66.8238 69.1585 66.8238 69.2561C66.8238 69.5488 66.6166 69.7927 66.3679 69.7927H63.2176C63.1347 69.7927 63.0622 69.7561 63 69.7195C63.0725 69.8902 63.2176 70 63.3938 70H66.544C66.7927 70 67 69.7561 67 69.4634C67 69.2561 66.8964 69.0854 66.7617 69Z",
    fill: "#DFE2ED"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M61.4981 70H59.5019C59.2281 70 59 69.7727 59 69.5C59 69.2273 59.2281 69 59.5019 69H61.4981C61.7719 69 62 69.2273 62 69.5C62 69.7727 61.7833 70 61.4981 70Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M62.6206 69C62.6917 69.093 62.7391 69.1977 62.7391 69.3139C62.7391 69.593 62.502 69.8256 62.2174 69.8256H60.1423C60.0949 69.8256 60.0474 69.814 60 69.8023C60.0949 69.9186 60.2371 70 60.4032 70H62.4783C62.7628 70 63 69.7674 63 69.4884C62.9881 69.2558 62.834 69.0581 62.6206 69Z",
    fill: "#DFE2ED"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M58.4981 70H56.5019C56.2281 70 56 69.7727 56 69.5C56 69.2273 56.2281 69 56.5019 69H58.4981C58.7719 69 59 69.2273 59 69.5C59 69.7727 58.7719 70 58.4981 70Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M58.4803 69H58.3976C58.4567 69.0795 58.5039 69.1818 58.5039 69.2841C58.5039 69.5568 58.2677 69.7841 57.9843 69.7841H56C56.0945 69.9091 56.2362 70 56.4134 70H58.4803C58.7638 70 59 69.7727 59 69.5C59 69.2273 58.7638 69 58.4803 69Z",
    fill: "#DFE2ED"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M54 70C54 69.4559 54.2206 69 54.5 69C54.7721 69 55 69.4412 55 70C55 70.5441 54.7794 71 54.5 71C54.2279 70.9853 54 70.5441 54 70Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M54.744 69C54.8 69.1774 54.832 69.371 54.832 69.5806C54.832 70.1774 54.592 70.6774 54.288 70.6774C54.184 70.6774 54.08 70.6129 54 70.5C54.096 70.8065 54.264 71 54.456 71C54.752 71 55 70.5161 55 69.9032C55 69.5323 54.896 69.1935 54.744 69Z",
    fill: "#DFE2ED"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M74.6187 87H45.3728C44.017 87 42.8068 87.5641 42 88.4564C42.5267 88.2513 43.1093 88.1282 43.7256 88.1282H72.9827C74.9661 88.1282 76.6357 89.3385 77.1735 91H79C78.9888 88.7949 77.0391 87 74.6187 87Z",
    fill: "#757D9C"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M94 20H22V23H94V20Z",
    fill: "#D1D5ED"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M100 20H95V21H100V20Z",
    fill: "#D1D5ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M100 21H95V22H100V21Z",
    fill: "#D1D5ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M100 22H95V23H100V22Z",
    fill: "#D1D5ED"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M45.1097 65C43.9426 65 43 64.0957 43 63C43 61.9043 43.9539 61 45.1097 61H76.8903C78.0574 61 79 61.9043 79 63C79 64.0957 78.0461 65 76.879 65H45.1097Z",
    fill: "#326AB3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M44.8264 65C43.8191 65 43 64.103 43 63C43 61.897 43.8191 61 44.8264 61H76.1736C77.1809 61 78 61.897 78 63C78 64.103 77.1809 65 76.1736 65H44.8264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M77.4655 62H45.5232C44.677 62 44 62.6778 44 63.5C44 64.3333 44.6883 65 45.5232 65H77.4768C78.323 65 79 64.3222 79 63.5C79 62.6667 78.3117 62 77.4655 62Z",
    fill: "#DCE9FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M73 62V65H45.5461C45.1254 65 44.7389 64.8339 44.4547 64.5572C44.1705 64.2804 44 63.9151 44 63.4945C44 62.6642 44.6935 62 45.5347 62H73Z",
    fill: "#70BDFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M36 66H39V63H36V66Z",
    fill: "#D1D5ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M32 66H35V61H32V66Z",
    fill: "#D1D5ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M27 66H30V59H27V66Z",
    fill: "#D1D5ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M23 66H26V57H23V66Z",
    fill: "#D1D5ED"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M46.5499 36.2364L36.8884 36.2606C36.7786 36.6849 36.4053 36.9879 35.9661 37C35.4282 37 35 36.5515 35 36.0061C35 35.4485 35.4282 35 35.9661 35C36.4053 35 36.7786 35.303 36.8994 35.7273L46.5608 35.703C46.8024 35.703 47 35.8242 47 35.9697C46.989 36.1152 46.7914 36.2364 46.5499 36.2364Z",
    fill: "#D1D5ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M60.0887 27.23C59.722 27.23 59.3998 27.44 59.2554 27.74H51.0111C50.9 27.31 50.5 27 50.0222 27C49.4555 27 49 27.44 49 27.98C49 28.52 49.4555 28.96 50.0222 28.96C50.5 28.96 50.9 28.64 51.0111 28.22H59.1776C59.222 28.66 59.6109 29 60.0887 29C60.5998 29 60.9998 28.61 60.9998 28.12C61.0109 27.62 60.5998 27.23 60.0887 27.23ZM50.0222 28.48C49.7333 28.48 49.4889 28.25 49.4889 27.97C49.4889 27.69 49.7222 27.46 50.0222 27.46C50.3111 27.46 50.5555 27.69 50.5555 27.97C50.5555 28.25 50.3222 28.48 50.0222 28.48Z",
    fill: "#D1D5ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M51.0889 55.23C50.7222 55.23 50.4 55.44 50.2556 55.74H42.0111C41.9 55.31 41.5 55 41.0222 55C40.4556 55 40 55.44 40 55.98C40 56.52 40.4556 56.96 41.0222 56.96C41.5 56.96 41.9 56.64 42.0111 56.22H50.1778C50.2222 56.66 50.6111 57 51.0889 57C51.5889 57 52 56.61 52 56.12C52 55.62 51.5889 55.23 51.0889 55.23ZM41.0222 56.47C40.7333 56.47 40.4889 56.24 40.4889 55.96C40.4889 55.68 40.7222 55.45 41.0222 55.45C41.3111 55.45 41.5556 55.68 41.5556 55.96C41.5556 56.25 41.3111 56.47 41.0222 56.47Z",
    fill: "#D1D5ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M58.4016 31H51.5984L44 51H50.3725L51.3554 47.6976H58.4458L59.4618 51H66L58.4016 31ZM52.7139 43.3783L54.9227 36.1832L57.1536 43.3783H52.7139Z",
    fill: "#D1D5ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M74 31H68V51H74V31Z",
    fill: "#D1D5ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M68.0007 25.2136C68.0007 25.0971 68.1238 25 68.2693 25L74.2243 25.0388L76.5077 26.9223L84.0409 26.9806C84.0521 26.9806 84.0633 26.9806 84.0745 26.9806C84.1864 26.6408 84.5782 26.3981 85.026 26.3981C85.5744 26.3981 86.011 26.767 85.9998 27.2039C85.9998 27.6408 85.552 28 85.0036 28C84.5446 28 84.1641 27.7476 84.0633 27.3981C84.0521 27.3981 84.0409 27.3981 84.0297 27.3981L76.2839 27.3398L73.9892 25.4757L68.2582 25.4369C68.1126 25.4272 67.9895 25.3301 68.0007 25.2136Z",
    fill: "#D1D5ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M86 59.2396C86 59.6562 85.6503 60 85.233 60C84.8833 60 84.59 59.7708 84.4998 59.4687H76.6601L74.562 57.4062H63.203C63.0902 57.4062 63 57.3125 63 57.2083C63 57.0937 63.0902 57 63.203 57H74.72L76.8181 59.0625H84.4772C84.5562 58.7292 84.8607 58.4792 85.2217 58.4792C85.6503 58.4792 86 58.8125 86 59.2396Z",
    fill: "#D1D5ED"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1328_6183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 95,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateAi);
export default __webpack_public_path__ + "static/media/GenerateAi.56c38056b6bd8bc91a7c5306e1a0be71.svg";
export { ForwardRef as ReactComponent };